export default (val) => Math.max(48, Math.round(val / 16) * 16);
